/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import ArrowStep from 'material/embeds/steps/stepindicator/arrowstep/arrowstep_container';
import Step from 'material/embeds/steps/stepindicator/step/step_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/steps/stepindicator/stepindicator_styles';



/* ========== ~~~~~~~~~~ STEP INDICATOR ~~~~~~~~~~ ========== */
class StepIndicator extends Component {
    constructor(props) {
        super(props);
        this.state = { phase: 'loading' };
        this.timeout = null;
    }
    componentDidMount() {
        this.timeout = setTimeout(() => {
            this.setState({ phase: 'loaded' });
        }, 10);
    }
    componentWillUnmount() {
        clearTimeout(this.timeout);
    }
    render() {
        return(
        	<div className={`stepindicator ${this.props.classes.stepindicator} ${this.state.phase} ${this.props.currentStepPage} isNewEmbedFlow-${this.props.isNewEmbedFlow}`}>
        		{this.props.stepQueue.map((step, index) => this.props.isNewEmbedFlow ? <ArrowStep index={index} data={step} key={index} /> : <Step index={index} data={step} key={index} />)}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(StepIndicator);
